import { render, staticRenderFns } from "./leagueCourserList.vue?vue&type=template&id=633c4dc4&scoped=true"
import script from "./leagueCourserList.vue?vue&type=script&lang=ts"
export * from "./leagueCourserList.vue?vue&type=script&lang=ts"
import style0 from "./leagueCourserList.vue?vue&type=style&index=0&id=633c4dc4&prod&lang=stylus&scoped=true"
import style1 from "./leagueCourserList.vue?vue&type=style&index=1&id=633c4dc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633c4dc4",
  null
  
)

export default component.exports